export const APP_NAME = process.env.REACT_APP_NAME || "求人紹介";
export const API_SUCCESS_MESSAGE = "保存しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 500;
export const MAX_INTEGER = 2147483646;
export const PASSWORD_CHANGE_SUCCESS_MESSAGE = "パスワードが再設定されました。";
export const CACHED_TIME = 10000;
export const MAXIMUM_NUMBER_VALIDATION = 9999999999999;
export const MAX_CHARACTER_INPUT_VALIDATION = 255;
export const MAX_COMPANY_INPUT_VALIDATION = 60;
export const MAX_REPRESENTATIVE_NAME_INPUT_VALIDATION = 26;
export const MAX_COMPANY_ADDRESS_INPUT_VALIDATION = 80;
export const MAX_TEXT_INPUT_VALIDATION = 1000;
export const MAX_INTEGER_INPUT_VALIDATION = 10;
export const MAX_YEAR_INPUT_VALIDATION = 4;
export const MAX_BIG_INTEGER = "9223372036854775807";
export const MAX_CHARACTER_FULLNAME_VALIDATION = 104;
export const MAX_CHARACTER_EMAIL_VALIDATION = 60;
export const MAX_CHARACTER_PHONE_VALIDATION = 15;
export const MAX_CHARACTER_ZIP_CODE = 7;
export const MAX_PARTNER_NAME_INPUT_VALIDATION = 60;
export const MAX_RECRUITMENT_SOURCE_NAME_INPUT_VALIDATION = 26;
export const MAX_MANAGEMENT_NUMBER_VALIDATION = 6;
export const PRIVACY_CONSENT_APPROVED_KEY = "privacy-consent-approved";
export const PRIVACY_CONSENT_APPROVED_VALUE = "approved";
